import { Typography, Form, Switch } from "antd";

const SMSNotifications = () => (
  <Form layout="vertical">
    <Form.Item name="smsNotifications" valuePropName="checked">
      <Switch />
    </Form.Item>
    <Typography.Paragraph>
      SMS bildirimlerini açmak veya kapatmak için yukarıdaki düğmeyi kullanın.
    </Typography.Paragraph>
  </Form>
);

export default SMSNotifications;
